import { ViewModel } from './_vm'

import FormStore from './store/_form-store'
import UiStore from '../store/_ui-store'
import tourCode from './const/tour_result.json'
import Collection from '../service/_collection'
import SearchConditions from './service/_searchConditions'

/**
 * GadgetDropdownSelect // セレクトのjs
 *
 * @returns {undefined}
 */
export class GadgetDropdownSelect extends ViewModel {
  constructor($element, controller) {
    super(GadgetDropdownSelect.name(), $element, controller)
    this.formName = this.$element.parents().attr('name')
    this.formValue = this.$element.attr('value')

    // イベントの登録

    console.log('GadgetDropdownSelect')
    this.$element.on('click', () => this.select())
    // this.on(`GadgetDropdownSelect`, () => this.render())

    // 様子見
    // this.render()
  }

  static name() {
    return 'GadgetDropdownSelect'
  }

  static className() {
    return '.js-kaigai-gadget-dropdown-select'
  }

  select() {
    FormStore.formSelect(this.formName, this.formValue)
    var selText = this.$element.text()
    this.selectedUpdate(this.formName)

    $('.dropdown')
      .find('[data-name=' + this.formName + '].dropdown-toggle')
      .html(selText)
  }

  selectedUpdate(formName) {
    if (FormStore.getData(formName, 'none') !== 'none') {
      UiStore.updateData(formName, FormStore.getData(formName, 'none'))
    }
    const filterList = UiStore.getData('filterList', 'none')
    const departureCode = UiStore.getData('departureCode', 'none')
    const areaCode = UiStore.getData('areaCode', 'none')
    const countryCode = UiStore.getData('countryCode', 'none')
    const cityCode = UiStore.getData('cityCode', 'none')
    const stayDays = String(UiStore.getData('stayDays', 'none'))
    const matchFlag = false
    // 出発地変更時処理

    const tourArray = new Collection(tourCode)

    const newFilterList = tourArray
      .filter(
        item =>
          departureCode !== 'none' &&
          stayDays !== 'none' &&
          item.airport_code === departureCode &&
          item.travel_days === stayDays,
      )
      .get()
    this.formFiltering()

    if (formName === 'areaCode') {
      $('.dropdown').find('[data-name=countryCode].dropdown-toggle').html('国・地域を選択')
      $('.dropdown').find('[data-name=cityCode].dropdown-toggle').html('都市を選択')
    }

    if (formName === 'countryCode') {
      $('.dropdown').find('[data-name=cityCode].dropdown-toggle').html('都市を選択')
    }
  }

  formFiltering() {
    if (this.formName === 'areaCode') {
      FormStore.updateData('countryCode', 'none')
      FormStore.updateData('cityCode', 'none')
    }
    if (this.formName === 'countryCode') {
      FormStore.updateData('cityCode', 'none')
    }

    const selectedOptions = [
      { key: 'airport_code', value: FormStore.getData('departureCode', 'none') },
      { key: 'area_code', value: FormStore.getData('areaCode', 'none') },
      { key: 'country_code', value: FormStore.getData('countryCode', 'none') },
      { key: 'city_code', value: FormStore.getData('cityCode', 'none') },
      { key: 'travel_days', value: String(FormStore.getData('stayDays', 'none')) },
    ]

    let selectedAreaOptions = [
      { key: 'airport_code', value: FormStore.getData('departureCode', 'none') },
      { key: 'travel_days', value: String(FormStore.getData('stayDays', 'none')) },
    ]

    const selectedCountryOptions = [
      { key: 'airport_code', value: FormStore.getData('departureCode', 'none') },
      { key: 'area_code', value: FormStore.getData('areaCode', 'none') },
      { key: 'travel_days', value: String(FormStore.getData('stayDays', 'none')) },
    ]

    const selectedCityOptions = [
      { key: 'airport_code', value: FormStore.getData('departureCode', 'none') },
      { key: 'area_code', value: FormStore.getData('areaCode', 'none') },
      { key: 'country_code', value: FormStore.getData('countryCode', 'none') },
      { key: 'travel_days', value: String(FormStore.getData('stayDays', 'none')) },
    ]

    const selectedStayDaysOptions = [{ key: 'airport_code', value: FormStore.getData('departureCode', 'none') }]

    if (this.formName === 'stayDays') {
      selectedAreaOptions = selectedStayDaysOptions
      const areaCode = FormStore.getData('areaCode', 'none')
      const countryCode = FormStore.getData('countryCode', 'none')
      const cityCode = FormStore.getData('cityCode', 'none')
      if (areaCode !== 'none') {
        selectedStayDaysOptions.push({ key: 'area_code', value: FormStore.getData('areaCode', 'none') })
      }
      if (countryCode !== 'none') {
        selectedStayDaysOptions.push({ key: 'country_code', value: FormStore.getData('countryCode', 'none') })
      }
      if (cityCode !== 'none') {
        selectedStayDaysOptions.push({ key: 'city_code', value: FormStore.getData('cityCode', 'none') })
      }
    }

    if (this.formName === 'areaCode') {
      selectedStayDaysOptions.push({ key: 'area_code', value: FormStore.getData('areaCode', 'none') })
    }

    if (this.formName === 'countryCode') {
      selectedStayDaysOptions.push({ key: 'country_code', value: FormStore.getData('countryCode', 'none') })
    }

    if (this.formName === 'cityCode') {
      selectedStayDaysOptions.push({ key: 'city_code', value: FormStore.getData('cityCode', 'none') })
    }

    // フィルタリング処理を効率化
    let filteredItems = new Collection(tourCode)
    let filteredDepartureCityItems = new Collection(tourCode)
    let filteredAreaItems = new Collection(tourCode)
    let filteredCountryItems = new Collection(tourCode)
    let filteredCityItems = new Collection(tourCode)
    let filteredStayDaysItems = new Collection(tourCode)

    const selectedDepartureCityOptions = [
      {
        key: 'departure_city_code',
        value: FormStore.getData('departureCode', 'none'),
      },
    ]
    // 選択されたオプションのみでフィルタリング
    selectedDepartureCityOptions.forEach(option => {
      if (option.value !== 'none') {
        filteredDepartureCityItems = filteredDepartureCityItems.filter(item => item[option.key] === option.value)
      }
    })

    if (filteredDepartureCityItems.get().length > 0) {
      selectedOptions.shift()
      selectedOptions.unshift(selectedDepartureCityOptions[0])
      selectedAreaOptions.shift()
      selectedAreaOptions.unshift(selectedDepartureCityOptions[0])
      selectedCountryOptions.shift()
      selectedCountryOptions.unshift(selectedDepartureCityOptions[0])
      selectedCityOptions.shift()
      selectedCityOptions.unshift(selectedDepartureCityOptions[0])
      selectedStayDaysOptions.shift()
      selectedStayDaysOptions.unshift(selectedDepartureCityOptions[0])
    }

    // 選択されたオプションのみでフィルタリング
    selectedOptions.forEach(option => {
      if (option.value !== 'none') {
        filteredItems = filteredItems.filter(item => item[option.key] === option.value)
      }
    })

    // 選択されたオプションのみでフィルタリング
    selectedAreaOptions.forEach(option => {
      if (option.value !== 'none') {
        filteredAreaItems = filteredAreaItems.filter(item => item[option.key] === option.value)
      }
    })

    // 選択されたオプションのみでフィルタリング
    selectedCountryOptions.forEach(option => {
      if (option.value !== 'none') {
        filteredCountryItems = filteredCountryItems.filter(item => item[option.key] === option.value)
      }
    })

    // 選択されたオプションのみでフィルタリング
    selectedCityOptions.forEach(option => {
      if (option.value !== 'none') {
        filteredCityItems = filteredCityItems.filter(item => item[option.key] === option.value)
      }
    })

    // 選択されたオプションのみでフィルタリング
    selectedStayDaysOptions.forEach(option => {
      if (option.value !== 'none') {
        filteredStayDaysItems = filteredStayDaysItems.filter(item => item[option.key] === option.value)
      }
    })

    const array1 = new Collection(filteredAreaItems.get())
      .map(item => {
        return { key: item.area_code, value: item.area_name }
      })
      .unshift({ key: 'none', value: '方面を選択' })
      .get()
    let filterAreaUnique = [...new Map(array1.map(itemObject => [itemObject.key, itemObject])).values()]

    let stayDaysFlagArea = false
    let stayDaysFlagCountry = false
    let stayDaysFlagCity = false

    // 出発地を変更した際に、選択済情報があるかないか判定。なければ選択項目の初期化
    if (this.formName === 'departureCode') {
      if (filterAreaUnique.some(item => item.key === FormStore.getData('areaCode', 'none'))) {
        stayDaysFlagArea = true
      } else {
        FormStore.updateData('areaCode', 'none')
        $('.dropdown').find('[data-name=areaCode].dropdown-toggle').html('方面を選択')
      }
    }

    const array2 = new Collection(filteredCountryItems.get())
      .map(item => {
        return { key: item.country_code, value: item.country_name }
      })
      .unshift({ key: 'none', value: '国・地域を選択' })
      .get()
    const filterCountryUnique = [...new Map(array2.map(itemObject => [itemObject.key, itemObject])).values()]

    // 出発地を変更した際に、選択済情報があるかないか判定。なければ選択項目の初期化
    if (this.formName === 'departureCode') {
      if (filterCountryUnique.some(item => item.key === FormStore.getData('countryCode', 'none'))) {
        stayDaysFlagCountry = true
      } else {
        FormStore.updateData('countryCode', 'none')
        $('.dropdown').find('[data-name=countryCode].dropdown-toggle').html('国・地域を選択')
      }
    }

    const array3 = new Collection(filteredCityItems.get())
      .map(item => {
        return { key: item.city_code, value: item.city_name }
      })
      .unshift({ key: 'none', value: '都市を選択' })
      .get()
    const filterCityUnique = [...new Map(array3.map(itemObject => [itemObject.key, itemObject])).values()]

    // 出発地を変更した際に、選択済情報があるかないか判定。なければ選択項目の初期化
    if (this.formName === 'departureCode') {
      if (filterCityUnique.some(item => item.key === FormStore.getData('cityCode', 'none'))) {
        stayDaysFlagCity = true
      } else {
        FormStore.updateData('cityCode', 'none')
        $('.dropdown').find('[data-name=cityCode].dropdown-toggle').html('都市を選択')
      }
    }

    selectedAreaOptions = selectedStayDaysOptions
    const departureCode = FormStore.getData('departureCode', 'none')
    const areaCode = FormStore.getData('areaCode', 'none')
    const countryCode = FormStore.getData('countryCode', 'none')
    const cityCode = FormStore.getData('cityCode', 'none')
    if (areaCode !== 'none') {
      selectedStayDaysOptions.push({ key: 'area_code', value: FormStore.getData('areaCode', 'none') })
    }
    if (countryCode !== 'none') {
      selectedStayDaysOptions.push({ key: 'country_code', value: FormStore.getData('countryCode', 'none') })
    }
    if (cityCode !== 'none') {
      selectedStayDaysOptions.push({ key: 'city_code', value: FormStore.getData('cityCode', 'none') })
    }
    if (departureCode === 'none' && areaCode === 'none' && countryCode === 'none' && cityCode === 'none') {
      selectedAreaOptions = [{ key: 'travel_days', value: String(FormStore.getData('stayDays', 'none')) }]
      filteredAreaItems = new Collection(tourCode)
      selectedAreaOptions.forEach(option => {
        if (option.value !== 'none') {
          filteredAreaItems = filteredAreaItems.filter(item => item[option.key] === option.value)
        }
      })
      const array1 = new Collection(filteredAreaItems.get())
        .map(item => {
          return { key: item.area_code, value: item.area_name }
        })
        .unshift({ key: 'none', value: '方面を選択' })
        .get()
      filterAreaUnique = [...new Map(array1.map(itemObject => [itemObject.key, itemObject])).values()]
    }
    // 選択されたオプションのみでフィルタリング
    selectedStayDaysOptions.forEach(option => {
      if (option.value !== 'none') {
        filteredStayDaysItems = filteredStayDaysItems.filter(item => item[option.key] === option.value)
      }
    })

    const array4 = new Collection(filteredStayDaysItems.get())
      .map(item => {
        return item.travel_days
      })
      .unshift({ key: 'none', value: '旅行日数を選択' })
      .get()
    const filterStayDaysUnique = [...new Map(array4.map(itemObject => [itemObject, itemObject])).values()]

    // 出発地を変更した際に、選択済情報があるかないか判定。なければ選択項目の初期化
    if (this.formName === 'departureCode') {
      if (filterStayDaysUnique.some(item => item === String(FormStore.getData('stayDays', 'none')))) {
      } else {
        FormStore.updateData('stayDays', 'none')
        $('.dropdown').find('[data-name=stayDays].dropdown-toggle').html('旅行日数を選択')
      }
    }

    console.log('this.formName', this.formName)
    const filterAreaList = SearchConditions.departureCodeToSelectData(
      FormStore.getData('departureCode', 'none'),
      filterAreaUnique,
    )
    FormStore.updateList('areaCode', filterAreaList)

    const filterCountryList = SearchConditions.areaCodeToSelectData(
      FormStore.getData('areaCode', 'none'),
      filterCountryUnique,
    )
    FormStore.updateList('countryCode', filterCountryList)

    const filterCityList = SearchConditions.countryCodeToSelectData(
      FormStore.getData('countryCode', 'none'),
      filterCityUnique,
    )
    FormStore.updateList('cityCode', filterCityList)

    const filterStayDaysList = SearchConditions.stayDaysList(filterStayDaysUnique)
    FormStore.updateList('stayDays', filterStayDaysList)

    this.trigger(`formSelect`)
    this.trigger(`FormUl`)
  }
}
